import React, { PureComponent } from "react";

export class Logo extends PureComponent {
  render() {
    const { alt, src, headLogoLink } = this.props;

    return (
      <a data-testid="t-Logo-a" className="logo-link" href={headLogoLink}>
        <img className="giving-nav-logo primary-color-border" src={src} alt={alt} />
      </a>
    );
  }
}

export default Logo;
